import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const ContactSection = styled('div')`
  border-top: ${fromTheme('border_width')} ${fromTheme('border_style')}
    ${fromTheme('color_border')};
  line-height: ${fromTheme('font_line_height')};
  font-size: ${fromTheme('font_size')};
  margin: 0 -${fromTheme('spacing_medium')};
  padding: ${fromTheme('spacing_medium')} ${fromTheme('spacing_medium')} 0;
`;
